import { parseAsString, useQueryStates } from '@vrplatform/query-params';

export function useStatementLinesDetailDrawer() {
  const [
    { ownerstatement: statementId, statementreservation: reservationId },
    setQuery,
  ] = useQueryStates({
    ownerstatement: parseAsString,
    statementreservation: parseAsString,
  });

  return {
    opened: !!statementId,
    values: {
      statementId,
      reservationId,
    },
    handlers: {
      close: () => setQuery(null),
      open: (value: { statementId: string; reservationId?: string }) =>
        setQuery({
          ownerstatement: value.statementId,
          statementreservation: value.reservationId,
        }),
    },
  };
}
